import { Injectable } from '@angular/core';

@Injectable({
  providedIn:'root'
})
export class AlertBannerService{
  public title: string;
  public message: string;
  public isVisible: boolean;

  constructor() {}

  setMessage(title: string, message: string) {
    this.title = title;
    this.message = message;
    this.show();
  }

  show() {
    this.isVisible = true;
  }

  hide() {
    this.isVisible = false;
  }

  toggle() {
    this.isVisible = !this.isVisible;
  }
}